<template>
  <div class="cos history-session">
    <div class="container column">
      <!-- Header -->
      <div class="list-header win-drag-bar">
        <div class="list-header-operate">
          <div class="session-title">
            <div class="session-icon-back no-drag-bar">
              <router-link to="/" replace><i class="cos-icon--16 for-backward"></i></router-link>
            </div>
            <div class="session-panel-h1">{{$t('cos.history_session')}}</div>
          </div>
        </div>
      </div>

      <!-- Body -->
      <div class="list-body">
        <div class="list-body-container">
          <div class="tc-action-grid pb-16">
            <button class="tc-15-btn c-xl btn-add" @click="onCreateSession">{{$t('core.create')}}</button>
          </div>
          <div class="tc-panel panel-table">
            <qc-table :empty-tips="$t('cos.tips.history_session_empty')" :list="list" :height="430"
              :row-class-name="()=>'session-row'">
              <qc-table-column type="collapse" field="SecretId" :visible.sync="visibleRows" accordion>
                <div slot="collapse" slot-scope="{ item }" class="session-detail-row">
                  <div class="tc-g">
                    <div class="tc-g-u-1-2 mt-8" v-for="(accessPath,index) in Object.keys(item.Contents).sort()"
                      :key="`content-${index}`">
                      <session-path-item v-model="credential" :region-map="regionMap"
                        :content="{...item.Contents[accessPath],...item}" @use="onUseSession"
                        @edit="openAccessPathDialog({...item.Contents[accessPath],...item})" @delete="onDelete">
                      </session-path-item>
                    </div>
                    <div class="tc-g-u-1-2 mt-8">
                      <div class="session-add-path" @click="openAccessPathDialog(item)">
                        <div class="cos-icon--16 addpath mr-20"></div>
                        {{$t('cos.add_access_path[0]')}}
                      </div>
                    </div>
                  </div>
                </div>
              </qc-table-column>

              <qc-table-column label="SecretId" :width="200">
                <template slot-scope="{ item }">
                  <div class="text-overflow" :title="`SecretId: ${item.SecretId}`">
                    {{item.simpleSecretId}}
                  </div>
                </template>
              </qc-table-column>

              <qc-table-column :label="$t('core.remark')">
                <template slot-scope="{ item }">
                  <div class="text-overflow session-desc" :title="item.Remark">
                    {{item.Remark|| $t("core.empty")}}
                  </div>
                </template>
              </qc-table-column>

              <qc-table-column :label="$t('core.action')" :width="150">
                <template slot-scope="{ item }">
                  <qc-button type="link" @click.stop="onUseSession(item)">{{$t('core.use')}}</qc-button>
                  <qc-button class="ml-5" type="link" @click.stop="onEditSession(item)">{{$t('core.edit')}}</qc-button>
                  <qc-button class="ml-5" type="link" @click.stop="onDelete(item)">{{$t('core.delete')}}</qc-button>
                </template>
              </qc-table-column>

            </qc-table>
            <div class="session-panel-ft">
              <button class="tc-15-btn c-m weak" @click="onReturn">{{$t('core.return')}}</button>
              <button class="tc-15-btn c-m ml-10" @click="onLogin">{{$t('core.login')}}</button>
            </div>
          </div>
        </div>
      </div>

      <create-path :show.sync="createAccessPathShow" :accessPathInfo="credential" :path-action="false"
        @submit="credential.Contents ? addPath($event) : editPath($event)" @cancel="resetCredential">
      </create-path>

      <create-or-edit-session :show.sync="sessionShow" :type="sessionType" :credential="credential"
        @submit="handleCreateOrEditSession($event);">
      </create-or-edit-session>

    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';

import { tips } from '@/scripts/tools/utils';
import user from '@/scripts/helper/user';
import keyBox from '@/scripts/helper/keyBox';
import menu from '@/scripts/helper/menu';
import sessionManagement from '@/scripts/mixins/sessionManagement';

import sessionPathItem from '@/components/common/sessionPathItem.vue';
import createPath from '@/components/dialog/bucket/createPath.vue';
import createOrEditSession from '@/components/dialog/others/createOrEditSession.vue';

export default {
  mixins: [sessionManagement],
  components: {
    sessionPathItem,
    createPath,
    createOrEditSession,
    // editSession,
  },
  data() {
    return {
      createAccessPathShow: false,
      sessionShow: false,
      sessionType: 'create', // create | edit
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.renderSessionRowEvent();
    });
  },
  methods: {
    renderSessionRowEvent() {
      const self = this;
      $('.session-row').on('click', e => {
        if (e.target.className === 'icon-arrow-right') return;

        const visibleRowIndex = _.findIndex(
          self.list,
          v => v.SecretId === self.visibleRows[0],
        );
        const currRowIndex = $(e.currentTarget).index();
        const realIndex = visibleRowIndex > -1 && visibleRowIndex < currRowIndex
          ? currRowIndex - 1
          : currRowIndex;
        const item = self.list[realIndex];
        const index = _.findIndex(self.visibleRows, v => v === item.SecretId);
        if (index > -1) {
          self.visibleRows = [];
        } else {
          self.visibleRows = [item.SecretId];
        }
      });
    },
    // 打开快速访问路径弹窗
    openAccessPathDialog(item) {
      this.credential = item;
      this.createAccessPathShow = true;
    },
    // 使用会话，跳转登录页
    onUseSession(item) {
      this.useSession(item);
      this.onReturn();
    },
    // 编辑会话弹窗
    async onEditSession(item) {
      const { SecretId } = item;
      this.credential = await keyBox.getSession(SecretId);
      this.sessionType = 'edit';
      this.sessionShow = true;
    },
    onCreateSession() {
      this.sessionType = 'create';
      this.sessionShow = true;
    },
    onDelete(item) {
      this.deleteSession(item);
    },
    async onLogin() {
      if (!this.credential) {
        tips.error(this.$t('error.choose_one_session'));
        return;
      }

      const { SecretId, AccessPath, Region } = this.credential;

      const session = await keyBox.getSession(SecretId);
      const { SecretKey } = session;
      if (!SecretKey) {
        tips.error(this.$t('cos.validate.secret_key_empty'));
        return;
      }

      session.AccessPath = AccessPath;
      session.Region = Region;

      user.setCredential(session);
      if (AccessPath && Region) {
        user.login({ keyType: 'SecretKey' });
        this.$store.showSideBar = false;
      } else {
        tips.loading(window.lang.t('core.loading'));
        menu.getList(data => {
          const result = data.result || {};
          tips.closeTips();

          // 过滤掉子账号登录的报错
          if (result.message) {
            if (
              AccessPath
              && result.message
                === window.lang.t('error.needAccessPathOrGetServiceAccess')
            ) {
              // console.log('子账号登录,忽略报错信息');
            } else {
              tips.error(result.message);
            }
          }

          if (result.allow) {
            user.login({ keyType: 'SecretKey' });
          } else {
            user.setCredential(null);
          }
        });
      }
      this.computeCrumbs(AccessPath, Region);
    },
    computeCrumbs(AccessPath, region) {
      if (AccessPath) {
        const bucket = AccessPath.substr(0, AccessPath.indexOf('/'));
        const path = AccessPath.substr(AccessPath.indexOf('/'));

        const prefix = (path || '').replace(/^\//, '');

        const query = { bucket, region, path: prefix };
        if (!query.path) delete query.path;
        this.$router.replace({ name: 'file', query }).catch(() => {});
      } else {
        this.$router.replace({ name: 'bucket' }).catch(() => {});
      }
    },
    onReturn() {
      this.$router.replace({ name: 'login' }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 680px;
  .list-header {
    margin-top: 20px;
  }
  ::v-deep .tc-15-table-rowhover tbody tr:hover,
  .session-add-path:hover {
    background-color: #e6f1ff;
  }
}
// 若窗体有边框，则将高度减掉边框像素
.windows-border {
  .container {
    height: 678px;
  }
}
</style>
